<template>
  <a-modal :zIndex="1000" centered :width="850" destroyOnClose
    :visible="showModal"
    :title="`${liveDetail.liveId ? '编辑' : '创建'}直播`" @cancel="handleClose" @ok="handleOk">
    <div class="create-course-container">
      <a-tabs
        :activeKey="curTab"
        tab-position="left"
        @tabClick="tabClick"
      >
        <a-tab-pane v-for="i in tabs" :key="i.key" :tab="i.text">
          <div class="pane-container scrollableBar">
            <div class="pane-tit">{{ i.text }}</div>
            <a-form-model layout="vertical"
              ref="liveForm"
              :rules="rules"
              :model="formModel"
            >
              <div class="pane-wrap" v-if="i.key === '1'">
                <a-row :gutter="20">
                  <a-col :span="12">
                    <a-form-model-item label="直播名称" prop="liveName" key="liveName">
                      <a-input
                        :disabled="liveDetail.liveStatus === LIVE_STATUS.END"
                        v-model="formModel.liveName"
                        placeholder="请输入直播名称"
                        autocomplete="off"
                        :maxLength="50"
                        allowClear
                      />
                    </a-form-model-item>
                  </a-col>
                </a-row>

                <a-row :gutter="20">
                  <a-col :span="12">
                    <a-form-model-item label="直播负责人" prop="liveMasterId" key="liveMasterId">
                      <a-select
                        :disabled="liveDetail.liveStatus === LIVE_STATUS.ING || liveDetail.liveStatus === LIVE_STATUS.END"
                        show-search
                        v-model="formModel.liveMasterId"
                        placeholder="请选择直播负责人"
                        :default-active-first-option="false"
                        :show-arrow="true"
                        :filter-option="false"
                        :not-found-content="null"
                        :loading="teacherListLoading"
                        @search="searchTeacherList"
                        @change="handleChangeTeacher"
                        @popupScroll="getMore"
                      >
                        <a-select-option :value="teacher.userId" v-for="teacher in teacherList" :key="teacher.userId" :teacher="teacher">
                          {{ `${teacher.username || '--'}(${teacher.phone || '--'})` }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="12">
                    <a-form-model-item label="自定义对外展示“老师名称”">
                      <a-input
                        :disabled="liveDetail.liveStatus === LIVE_STATUS.END"
                        v-model="displayTeacherName"
                        placeholder="请输入对外展示“老师名称”" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="20">
                  <a-col :span="12">
                    <a-form-model-item label="助教">
                      <director-selector
                        :disabled="liveDetail.liveStatus === LIVE_STATUS.ING || liveDetail.liveStatus === LIVE_STATUS.END"
                        :defaultValue="directorList" @changeDirectorList="changeDirectorList"/>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="20">
                  <a-col :span="24">
                    <a-form-model-item label="授课时间" required>
                      <course-date-single
                        :disabled="liveDetail.liveStatus === LIVE_STATUS.ING || liveDetail.liveStatus === LIVE_STATUS.END"
                        :liveTimeObj="{
                          startTime: liveDetail.baseLiveInfo ? liveDetail.baseLiveInfo.startTime : null,
                          endTime: liveDetail.baseLiveInfo ? liveDetail.baseLiveInfo.endTime : null
                        }"
                        :showDateError="showDateError"
                        @changeTimeObj="changeLiveTimeObj"/>
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </div>
              <div class="pane-wrap" v-if="i.key === '2'">
                <a-row :gutter="20">
                  <a-col :span="11">
                    <a-form-model-item label="主讲学校" required>
                      <school-selector
                        :disabled="liveDetail.liveStatus === LIVE_STATUS.ING || liveDetail.liveStatus === LIVE_STATUS.END"
                        :schoolList="schoolList" :dataItem="speakerItem" @changeSchool="changeSpeakerSchool"/>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="13">
                    <a-form-model-item label="主讲教室">
                      <a-row  :gutter="20" style="display: flex;">
                        <a-col :span="21">
                          <classroom-selector
                            :disabled="liveDetail.liveStatus === LIVE_STATUS.ING || liveDetail.liveStatus === LIVE_STATUS.END"
                            :dataItem="speakerItem" @changeClassroom="changeSpeakerClassroom"/>
                        </a-col>
                      </a-row>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="20" v-show="speakerItem.classroomType == 12">
                  <a-col :span="11">
                    <a-form-model-item label="互动教室数量" required>
                      <a-select
                        v-model="speakerItem.interactiveRoomNum" placeholder="请选择互动教室数量"
                        :disabled="liveDetail.liveStatus === LIVE_STATUS.ING || liveDetail.liveStatus === LIVE_STATUS.END"
                      >
                        <a-select-option
                          v-for="num in numList"
                          :key="num"
                          :value="num">
                          {{ num }}
                        </a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="13">
                    <a-form-model-item label="允许学生加入">
                      <a-row  :gutter="20" style="display: flex;">
                        <a-col :span="21">
                          <a-switch
                            :disabled="liveDetail.liveStatus === LIVE_STATUS.ING || liveDetail.liveStatus === LIVE_STATUS.END || speakerItem.classroomType != 12"
                            :default-checked="speakerItem.allowStudentsJoin"
                            @change="onChangeAllowStudentsJoin" />
                        </a-col>
                      </a-row>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <div class="flex-form-item">
                  <a-row :gutter="20" >
                    <a-col :span="11">
                      <a-form-model-item label="听课学校">
                        <school-selector
                          :disabled="liveDetail.liveStatus === LIVE_STATUS.ING || liveDetail.liveStatus === LIVE_STATUS.END"
                          style="margin-bottom: 10px;"
                          v-for="listenerItem in listenerList" :key="listenerItem.index"
                          :schoolList="schoolList"
                          :dataItem="listenerItem"
                          @changeSchool="changeListenerSchool"/>
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="13">
                      <a-form-model-item label="听课教室">
                        <a-row :gutter="20" style="display: flex; margin-bottom:10px;"
                          v-for="(listenerItem, index) in listenerList" :key="index">
                          <a-col :span="21">
                            <classroom-selector
                              :disabled="liveDetail.liveStatus === LIVE_STATUS.ING || liveDetail.liveStatus === LIVE_STATUS.END"
                              :dataItem="listenerItem"
                              @changeClassroom="changeListenerClassroom"/>
                          </a-col>
                          <a-col :span="3" class="icon-container"
                            v-if="liveDetail.liveStatus !== LIVE_STATUS.ING && liveDetail.liveStatus !== LIVE_STATUS.END">
                            <i :class="`icon-btn ${index > 0 ? 'icon-remove' : 'icon-add'}`"
                              @click="changeListenerList(index > 0 ? 'remove' : 'add', index)"></i>
                          </a-col>
                        </a-row>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </a-form-model>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-modal>
</template>

<script>
import { checkRes } from '@/utils/tool'
import { createLive, editLive, searchUser } from '@/server/api/courseManage'
import { LIVE_STATUS } from '@/consts/live'
export default {
  name: 'CreateLiveModal',
  props: {
    courseInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    liveDetail: {
      type: Object,
      default() {
        return {}
      }
    },
    schoolList: {
      type: Array,
      default() {
        return []
      }
    },
    showModal: Boolean
  },
  components: {
    'director-selector': () => import('./DirectorSelector'),
    'school-selector': () => import('./SchoolSelector'),
    'classroom-selector': () => import('./ClassroomSelector'),
    'course-date-single': () => import('./CourseDateSingle'),
  },
  watch: {
    liveDetail: {
      handler(nVal) {
        const { baseLiveInfo = {}, teachClassroom = {}, watchClassroom } = nVal || {}
        this.formModel.liveName = baseLiveInfo.liveName
        this.formModel.liveMasterId = baseLiveInfo.userId
        this.displayTeacherName = baseLiveInfo.teacherName
        this.directorList = baseLiveInfo.directorUserId || []

        this.liveTimeObj = {
          startTime: baseLiveInfo.startTime,
          endTime: baseLiveInfo.endTime
        }
        this.speakerItem = {
          id: teachClassroom.id,
          schoolId: teachClassroom.schoolCode,
          classroomCode: teachClassroom.classroomCode,
          interactiveRoomNum: teachClassroom.interactiveRoomNum || 0,
          allowStudentsJoin: !!teachClassroom.allowStudentsJoin,
          classroomType: teachClassroom.classroomType,
        }
        const watchClassroomTemp = (watchClassroom || []).length ? watchClassroom : [{index: 0}]
        this.listenerList = watchClassroomTemp.map((item, index) => ({
          index: item.index,
          id: item.id,
          schoolId: item.schoolCode,
          classroomCode: item.classroomCode
        }))

        this.searchTeacherList(baseLiveInfo.username || '')
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      numList: [0,1,2,3,4],
      LIVE_STATUS,
      speakerSchoolErr: false,
      formModel: {
        liveName: '', // 直播名称
        liveMasterId: undefined, // 直播负责人
      },
      rules: {
        liveName: [
          { required: true, message: '请输入直播名称（限50字）', trigger: 'change' }
        ],
        liveMasterId: [
          { required: true, message: '请选择直播负责人', trigger: 'change' }
        ],
      },
      curTab: '1',
      tabs: [{
        key: '1',
        text: '基础信息'
      }, {
        key: '2',
        text: '教室配置'
      }],

      displayTeacherName: '', // 对外展示“老师名称”

      teacherListLoading: false,
      teacherListRt: {},
      teacherListPageNum: 1,
      teacherListPageSize: 20,
      teacherList: [], // 老师列表

      courseMaster: {}, // 直播负责人
      directorList: [], // 导播人员
      liveTimeObj: {
        startTime: '',
        endTime: '',
      }, // 授课时间
      showDateError: false,

      speakerItem: { // 主讲学校教室
        schoolId: undefined, // 主讲学校
        classroomCode: undefined, // 主讲教室
        interactiveRoomNum: 0, // 互动教室数量
        allowStudentsJoin: 0, // 是否允许学生加入
        classroomType: undefined, // 主讲教室类型
      },
      listenerList: [ // 听课学校列表
        {
          index: 0,
          schoolId: undefined,
          classroomCode: undefined
        }
      ], // 听课教室

    }
  },
  mounted() {
  },
  methods: {
    handleChangeTeacher(value, option) {
      this.formModel.liveMasterId = value
      this.courseMaster = option.data.attrs.teacher
      this.displayTeacherName = this.courseMaster.username
    },

    tabClick(value) {
      this.curTab = value
    },
    handleOk() {
      this.$refs.liveForm[0].validate(valid => {
        if (valid) {
          console.log(1091, this.speakerItem)
          if (this.directorList.find(i => i == this.formModel.liveMasterId)) {
            this.$message.error('直播负责人与导播老师不能重复！')
            return
          }
          if (!this.liveTimeObj.startTime || !this.liveTimeObj.endTime) {
            this.showDateError = true
            this.curTab = '1'
            return
          }
          if (!this.speakerItem.schoolId) {
            this.curTab = '2'
            this.speakerSchoolErr = true
            return
          }
          if (this.liveDetail.liveId) {
            this.goEditLive()
          } else {
            this.goCreateLive()
          }
        } else {
          return false;
        }
      })
    },
    // 直播负责人
    changeCourseMaster(value) {
      this.formModel.liveMasterId = value
    },
    // 导播变化
    changeDirectorList(value) {
      this.directorList = value
    },
    // 授课时间列表
    changeLiveTimeObj(value) {
      this.liveTimeObj = {
        startTime: new Date(value.startDateTime).getTime(),
        endTime: new Date(value.endDateTime).getTime()
      }
    },
    // 主讲学校变化
    changeSpeakerSchool(value) {
      this.speakerSchoolErr = false
      this.speakerItem.schoolId = value.schoolId
    },
    // 主讲教室变化
    changeSpeakerClassroom(value) {
      this.speakerItem.classroomCode = value.classroomCode
      this.speakerItem.classroomType = value.classroomType
    },
    // 主讲教室，是否允许学生加入
    onChangeAllowStudentsJoin(checked) {
      this.speakerItem.allowStudentsJoin = checked
    },

    // 听课学校变化
    changeListenerSchool(value) {
      const targetIndex = this.listenerList.findIndex(i => i.index === value.index)
      this.listenerList[targetIndex].schoolId = value.schoolId
    },
    // 听课学校、教室变化
    changeListenerClassroom(value) {
      const targetIndex = this.listenerList.findIndex(i => i.index === value.index)
      this.listenerList[targetIndex].classroomCode = value.classroomCode
    },
    // 增加删除听课学校、教室
    changeListenerList(option, index) {
      if (option === 'add') {
        const lastItem = this.listenerList[this.listenerList.length - 1]
        this.listenerList.push({ index: (lastItem.index || 0) + 1, schoolId: undefined, classroomCode: undefined })
        return
      }
      if (option === 'remove') {
        this.listenerList.splice(index, 1)
      }
    },
    handleClose() {
      this.$emit('close', false)
      this.curTab = '1'
    },
    // 新建直播
    async goCreateLive() {
      const self = this
      const { liveName, liveMasterId} = self.formModel
      const {
        displayTeacherName, directorList,  liveTimeObj,
        speakerItem, listenerList
      } = self
      const res = await createLive({
        courseId: this.courseInfo.courseId,
        baseLiveInfo: {
          liveName: liveName,
          directorUserId: directorList,
          teacherName: displayTeacherName,
          startTime: liveTimeObj.startTime,
          endTime: liveTimeObj.endTime,
          userId: liveMasterId
        },
        teachClassroom: {
          classroomCode: speakerItem.classroomCode,
          schoolCode: speakerItem.schoolId,
          classroomType: speakerItem.classroomType,
          interactiveRoomNum: speakerItem.classroomType == 12 ? speakerItem.interactiveRoomNum : undefined,
          allowStudentsJoin:  speakerItem.classroomType == 12 ? (speakerItem.allowStudentsJoin ? 1 : 0) : undefined
        },
        watchClassroom: listenerList
          .filter(i => !!i.schoolId)
          .map(i => ({ classroomCode: i.classroomCode, schoolCode: i.schoolId })),
      })
      checkRes({
        res,
        success(data) {
          self.$emit('refresh', false)
          self.handleClose()
          self.$message.success('创建成功')
        },
        failed(err) {
          self.$message.error('创建失败')
        }
      })
    },
    async goEditLive() {
      const self = this
      const { liveDetail } = self
      const { liveName, liveMasterId} = self.formModel
      const {
        displayTeacherName, directorList,  liveTimeObj,
        speakerItem, listenerList
      } = self
      const res = await editLive({
        liveId: liveDetail.liveId,
        baseLiveInfo: {
          liveName: liveName,
          directorUserId: directorList,
          teacherName: displayTeacherName,
          startTime: liveTimeObj.startTime,
          endTime: liveTimeObj.endTime,
          userId: liveMasterId
        },
        teachClassroom: {
          id: speakerItem.id,
          classroomCode: speakerItem.classroomCode,
          schoolCode: speakerItem.schoolId,
          classroomType: speakerItem.classroomType,
          interactiveRoomNum: speakerItem.classroomType == 12 ? speakerItem.interactiveRoomNum : undefined,
          allowStudentsJoin:  speakerItem.classroomType == 12 ? (speakerItem.allowStudentsJoin ? 1 : 0) : undefined
        },
        watchClassroom: listenerList
          .filter(i => !!i.schoolId)
          .map(i => ({
          id: i.id,
          classroomCode: i.classroomCode,
          schoolCode: i.schoolId
        })),
      })
      checkRes({
        res,
        success(data) {
          self.$emit('refresh', false)
          self.handleClose()
          self.$message.success('编辑成功')
        },
        failed(err) {
          self.$message.error('编辑失败')
        }
      })
    },
    getMore(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target
      const { teacherListLoading, teacherListPageSize, teacherListPageNum, teacherListRt } = this
      if (teacherListLoading) return
      if (scrollHeight - scrollTop < clientHeight + 20) {
        if ( teacherListPageNum * teacherListPageSize < teacherListRt.totalCount) {
          this.teacherListPageNum = teacherListPageNum + 1
          this.getTeacherList()
        }
      }
    },
    searchTeacherList(keyword) {
      this.teacherListPageNum = 1
      this.getTeacherList(keyword)
    },
    // 获取当前选中机构的所有老师
    async getTeacherList(keyword) {
      const self = this
      self.teacherListLoading = true
      const res = await searchUser({
        keywords: keyword,
        pageSize: self.teacherListPageSize,
        pageNum: self.teacherListPageNum
      })
      checkRes({
        res,
        success(data) {
          self.teacherListRt = data
          if (self.teacherListPageNum > 1) {
            self.teacherList = [...self.teacherList, ...data.list]
          } else {
            self.teacherList = data.list
          }
        }
      })
      self.teacherListLoading = false
    }
  }
}
</script>

<style>
  .ant-tabs-nav .ant-tabs-tab-active {
    color: #5F60D3;
  }
  .ant-tabs-ink-bar {
    background-color: #5F60D3;
  }
  .ant-modal-footer {
    text-align: center;
  }
  .ant-btn-primary {
    background-color: #5F60D3;
    border-color: #5F60D3;
  }
</style>
<style lang="scss" scoped>
.create-course-container{
  height: 400px;
  overflow: hidden;
  .pane-container{
    height: 400px;
    overflow-y: auto;
    padding-right: 20px;
    .pane-tit{
      font-weight: bold;
      margin-bottom: 10px;
    }
    .icon-container{
      display: flex;
      align-items: center;
      .icon-btn {
        display: inline-block;
        width: 20px;
        height: 20px;
        background-repeat: no-repeat;
        background-size: cover;
        cursor: pointer;
        &:hover{
          opacity: 0.9;
        }
        &.icon-add{
          background-image: url('../../../../img/icon-add@2x.png');
        }
        &.icon-remove{
          background-image: url('../../../../img/icon-remove@2x.png');
        }
      }
    }

  }
}
</style>